"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSessionEvent = exports.MAX_NUMBER_OF_MODULES = exports.MAX_SESSION_TIME_DIFF_SECONDS = void 0;
const date_fns_1 = require("date-fns");
const Session_1 = require("../types/Session");
const isValidTimestamp_1 = require("./isValidTimestamp");
exports.MAX_SESSION_TIME_DIFF_SECONDS = 86400; // one day
exports.MAX_NUMBER_OF_MODULES = 5000;
function validateSessionEvent(validSessionStats, clientSessionStats, now = new Date()) {
    const { session: clientSession, modules } = clientSessionStats;
    if (clientSession.sessionType === Session_1.SessionType.notesOnly) {
        return null;
    }
    const validSession = validSessionStats;
    const { timeStarted: timeStartedTimestamp, timeFinished: timeFinishedTimestamp } = clientSession;
    const timeStarted = new Date(timeStartedTimestamp);
    const timeFinished = new Date(timeFinishedTimestamp);
    const validationErrorReasons = [];
    if (!clientSession.courseId) {
        validationErrorReasons.push(`Session does not have courseId`);
    }
    if (!clientSession.sectionIds) {
        validationErrorReasons.push(`Session does not have sectionIds`);
    }
    else if (!clientSession.sectionIds.length) {
        validationErrorReasons.push(`Session has empty sectionIds`);
    }
    const allModulesHaveContentId = modules.every(module => !!module.contentId);
    if (!allModulesHaveContentId) {
        validationErrorReasons.push(`Session has some modules without contentId`);
    }
    if (modules.length > exports.MAX_NUMBER_OF_MODULES) {
        validationErrorReasons.push(`Session has too many modules (${modules.length})`);
    }
    for (const key in validSession) {
        if (clientSession[key] !== validSession[key]) {
            validationErrorReasons.push(`Session aggregation check failed, expected ${key}=${validSession[key]}, received ${key}=${clientSession[key]}`);
        }
    }
    if (!(0, isValidTimestamp_1.isValidTimestamp)(timeFinishedTimestamp)) {
        validationErrorReasons.push(`timeFinished value (${timeFinishedTimestamp}) is not valid`);
    }
    if (!(0, isValidTimestamp_1.isValidTimestamp)(timeStartedTimestamp)) {
        validationErrorReasons.push(`timeStarted value (${timeStartedTimestamp}) is not valid`);
    }
    if (!modules.every(module => (0, isValidTimestamp_1.isValidTimestamp)(module.timeStarted))) {
        validationErrorReasons.push(`module timeStarted value is not valid`);
    }
    if (!modules.every(module => (0, isValidTimestamp_1.isValidTimestamp)(module.timeFinished))) {
        validationErrorReasons.push(`module timeFinished value is not valid`);
    }
    if (Math.abs((0, date_fns_1.differenceInSeconds)(now, timeStarted)) >
        exports.MAX_SESSION_TIME_DIFF_SECONDS) {
        validationErrorReasons.push(`timeStarted value (${(0, date_fns_1.formatISO)(timeStarted)}) time difference is greater than ${exports.MAX_SESSION_TIME_DIFF_SECONDS}s`);
    }
    if (Math.abs((0, date_fns_1.differenceInSeconds)(now, timeFinished)) >
        exports.MAX_SESSION_TIME_DIFF_SECONDS) {
        validationErrorReasons.push(`timeFinished value (${(0, date_fns_1.formatISO)(timeFinished)}) time difference is greater than ${exports.MAX_SESSION_TIME_DIFF_SECONDS}s`);
    }
    return validationErrorReasons.length ? validationErrorReasons : null;
}
exports.validateSessionEvent = validateSessionEvent;
